import { COUNTRY } from './constants';

// Canadian Software Options
export const CA_SOFTWARE_OPTIONS = [
  'Dentrix',
  'ABELDent',
  'ClearDent',
  'Paradigm Clinical',
  'Tracker',
  'Progident/Clinique',
  'Power Practice',
  'Open Dental',
  'Dentitek',
  'MaxiDent',
  'Other'
];

// US Software Options
export const US_SOFTWARE_OPTIONS = [
  'MaxiDent',
  'ClearDent',
  'Dentrix',
  'Curve Dental/Curve Hero',
  'Open Dental',
  'ABELDent',
  'ADSTRA Dental',
  'Oryx Dental Software',
  'CareStack',
  'EagleSoft',
  'Other'
];

// Get software options based on country
export const getSoftwareOptions = (country: number) => {
  return country === COUNTRY.US ? US_SOFTWARE_OPTIONS : CA_SOFTWARE_OPTIONS;
}; 